import { styled, Rating } from '@mui/material';

export const StarRatingStyled = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconFilled': {
    color: theme.palette.common.black,
  },
}));
